import { Person } from '~/layers/forms/models'

import type { User } from '#auth-utils'

export type Customer = Person

function load(model?: Partial<Customer> | null, user?: User | null): Customer {
  return Person.load(model, user)
}

export const CustomerTypeEnum = {
  Person: { label: 'Persona', code: 'Person' },
  Business: { label: 'Empresa', code: 'Business' },
} as const

function getCustomerTypeList() {
  return Object.values(CustomerTypeEnum)
}

export const Customer = {
  load,
  getCustomerTypeList,
}
